// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"Social_wrapper__2B2jP","title":"Social_title__2zFVk","list":"Social_list__34V_R","item":"Social_item__2wxqC"};